import { render } from "./Errorpage.vue?vue&type=template&id=04eb443b&scoped=true"
import script from "./Errorpage.vue?vue&type=script&lang=js"
export * from "./Errorpage.vue?vue&type=script&lang=js"

import "./Errorpage.vue?vue&type=style&index=0&id=04eb443b&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/flint.ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04eb443b"]])

export default __exports__